import { getRandomColor } from '../../../utils';
import { DomainToken, DomainTokenGroup, WorkspaceToken } from '../model/auth.model';
import { Store } from './base.store';
import { CommonStoreKey, SignInStoreKey, SignUpStoreKey } from './store-keys';

export class AuthStore extends Store {
  /**临时token */
  get tempToken() {
    return this.localStorage.retrieve(SignUpStoreKey.TempToken) || null;
  }

  set tempToken(value: string) {
    this.localStorage.store(SignUpStoreKey.TempToken, value);
  }

  /** 注册使用的邮箱 */
  get signUpEmail() {
    return this.localStorage.retrieve(SignUpStoreKey.SignUpEmail);
  }

  set signUpEmail(value: string) {
    this.localStorage.store(SignUpStoreKey.SignUpEmail, value);
  }

  /** 邀请验证码 */
  get inviteCode() {
    return this.localStorage.retrieve(SignUpStoreKey.InviteCode);
  }

  set inviteCode(value: string) {
    this.localStorage.store(SignUpStoreKey.InviteCode, value);
  }

  /** 发出邀请的公司名 */
  get companyName() {
    return this.localStorage.retrieve(SignUpStoreKey.CompanyName) || 'STREAM';
  }

  set companyName(value: string) {
    this.localStorage.store(SignUpStoreKey.CompanyName, value);
  }

  /** domain */
  get domainPrefix() {
    return this.localStorage.retrieve(SignUpStoreKey.DomainPrefix) || '';
  }

  set domainPrefix(value: string) {
    this.localStorage.store(SignUpStoreKey.DomainPrefix, value);
  }

  /** 发送邮件倒计时 */
  get sendCodeTimer() {
    return this.localStorage.retrieve(CommonStoreKey.SendCodeTimer);
  }

  set sendCodeTimer(value: number | undefined) {
    this.localStorage.store(CommonStoreKey.SendCodeTimer, value);
  }

  /** 登录发送邮件倒计时 */
  get sendSignInCodeTimer() {
    return this.localStorage.retrieve(SignInStoreKey.SendCodeTimer);
  }

  set sendSignInCodeTimer(value: number | undefined) {
    this.localStorage.store(SignInStoreKey.SendCodeTimer, value);
  }

  /** 本地邀请临时Token */
  get inviteDomainToken() {
    return this.localStorage.retrieve(SignUpStoreKey.InviteDomainToken) || null;
  }

  set inviteDomainToken(value: DomainToken) {
    this.localStorage.store(SignUpStoreKey.InviteDomainToken, value);
  }

  /** 本地临时domainToken */
  get tempDomainToken() {
    return this.localStorage.retrieve(SignInStoreKey.DomainToken) || null;
  }

  set tempDomainToken(value: DomainToken) {
    this.localStorage.store(SignInStoreKey.DomainToken, value);
  }

  /** 所有已登陆的域信息 */
  get domainTokenGroup(): DomainTokenGroup[] {
    return this.localStorage.retrieve(SignInStoreKey.DomainTokenGroup) || [];
  }

  set domainTokenGroup(value: DomainTokenGroup[] | undefined) {
    this.localStorage.store(SignInStoreKey.DomainTokenGroup, value);
  }

  /**
   * 获取选定子域的 Token
   *
   * @type {(DomainToken | null)} 子域的 Token
   * @memberof AuthStore
   */
  get domainToken(): DomainToken | null {
    return this.localStorage.retrieve(SignInStoreKey.DomainToken);
  }

  /**
   * 设置选定子域的 Token
   *
   * @memberof AuthStore
   */
  set domainToken(domain: DomainToken | null) {
    if (!domain) {
      this.localStorage.clear(SignInStoreKey.DomainToken);
      return;
    }
    this.localStorage.store(SignInStoreKey.DomainToken, domain ?? '');
  }

  /** v88 workspace token */
  get workspaceToken(): WorkspaceToken | null {
    return this.localStorage.retrieve(SignInStoreKey.DomainToken);
  }

  set workspaceToken(token: WorkspaceToken | null) {
    if (!token) {
      this.localStorage.clear(SignInStoreKey.DomainToken);
      return;
    }
    this.localStorage.store(SignInStoreKey.DomainToken, token);
  }

  /** 当前子域AccessToken */
  get accessToken() {
    return this.workspaceToken?.accessToken ?? null;
  }

  /** 当前子域RefreshToken */
  get refreshToken() {
    return this.workspaceToken?.refreshToken ?? null;
  }

  get loginEmail() {
    return this.workspaceToken?.gpAccountEmail;
  }

  addWorkspaceToken(params: { tokenInfo: WorkspaceToken }) {
    this.workspaceToken = {
      ...params.tokenInfo
    };
  }

  clearDomainToken() {
    this.domainTokenGroup = [];
    this.workspaceToken = null;
  }

  /** 当前正在登录的邮箱 */
  get signInUserEmail() {
    return this.localStorage.retrieve(SignInStoreKey.SignInUserEmail);
  }

  set signInUserEmail(value: string) {
    this.localStorage.store(SignInStoreKey.SignInUserEmail, value);
  }

  /**
   * 本地添加tokenGroup
   * @param email 邮件
   * @param domains 域信息
   */
  addDomainToken(email: string, domains: DomainToken[]) {
    this.domainTokenGroup = [
      {
        email,
        domains: domains?.map(item => ({ ...item, color: getRandomColor() }))
      }
      // ...this.domainTokenGroup.filter(
      //   ({ email: groupEmail }) => email !== groupEmail
      // ),
    ];
  }

  /**
   * 清空本地存储注册信息
   */
  clearSignUpStore() {
    this.localStorage.clear(SignUpStoreKey.TempToken);
    this.localStorage.clear(SignUpStoreKey.InviteCode);
    this.localStorage.clear(SignUpStoreKey.SignUpEmail);
    this.localStorage.clear(SignUpStoreKey.SendCodeTimer);
    this.localStorage.clear(SignUpStoreKey.CompanyName);
    this.localStorage.clear(SignUpStoreKey.DomainPrefix);
  }
}
